export const Version = {
  V1: 'v1',
  V2: 'v2',
} as const;

export type Version = (typeof Version)[keyof typeof Version];
